"use client";

import Image from "next/image";

import { TopJoinersWidgetView } from "@/components/app/app-layout/sidebar-top-resutls-widget/top-joiners-widget-view";
import { TimePeriod } from "@/components/app/discover-sort-constants";
import UserSearch from "@/components/shared/users-search/user-search";
import { DISCOVER_WIDGET_TOP_WALLETS_PRESET } from "@/utils/discover-widget";

import { ServerPageListener } from "./server-page-listener";

export const SearchWallets = () => {
  return (
    <ServerPageListener>
      <div
        className="
          mx-auto flex max-w-[600px] flex-col items-center p-6
          sm:min-h-screen sm:justify-center
        "
      >
        <Image
          src="/assets/empty-18.png"
          alt="Wallet Search Illustration"
          width={100}
          height={0}
          className="mb-6"
        />
        <h2
          className="
            mb-2 text-center font-sans text-2xl font-semibold
            text-muted-foreground
          "
        >
          Search Wallets
        </h2>
        <p
          className="
          mx-auto mb-4 text-center text-sm/6 text-balance text-muted
        "
        >
          On Focus, all assets &amp; holdings are publicly viewable so you can
          get deeper insights into who you're interacting with.
        </p>
        <div className="mb-6 flex w-full justify-center">
          <UserSearch
            placeholder="Search users..."
            baseRedirectUrl="/wallet/"
          />
        </div>
        <div className="w-full rounded-2xl border">
          <TopJoinersWidgetView
            preset={DISCOVER_WIDGET_TOP_WALLETS_PRESET}
            selectedTimePeriod={TimePeriod.AllTime}
            baseRedirectUrl="/wallet/"
          />
        </div>
      </div>
    </ServerPageListener>
  );
};
